import styled from "styled-components";

const StyledDiv = styled.div`
  flex: 1;

  .animation-wrapper {
    top: 0px;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    background-color: red;
    border-radius: 10px;
    cursor: pointer;
    background-color: white;
    width: 100%;

    .user-item-cont {
      flex: 1;
      min-width: 0;
      margin-left: 0.5rem;

      .user-item {
        flex: 1;
        border-radius: 10px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;

        .user-item-content {
          display: flex;
          justify-content: start;
          align-items: center;
          width: 100%;
          gap: 0.5rem;

          .user-picture-cont {
            position: relative;
          }
        }

        .unread-message {
          position: absolute;
          top: 0px;
          right: 0px;
          width: 14px;
          height: 14px;

          border-radius: 100%;
          background-color: green;
        }

        &--selected {
          background-color: rgba(218, 218, 218, 0.5);
        }

        &--no-selected {
          transition: none;

          &:hover {
            background-color: rgba(218, 218, 218, 0.2);
          }
        }
      }

      .user-item-text-cont {
        overflow: hidden;
        display: flex;
        flex-flow: column nowrap;
        gap: 2px;

        .user-item-text {
          width: 100%;
          min-width: 0;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
`;

export default StyledDiv;
